import { useCallback } from "react";

import { apiClient } from "@/features/shared";
import { CustomAutocomplete } from "@/features/ui";

export const RoleSelect = (props) => {
  const fetchRoles = useCallback(async (searchValue) => {
    const {
      data: { data },
    } = await apiClient.get("roles", {
      params: {
        name: searchValue,
      },
    });
    return data;
  }, []);

  return (
    <CustomAutocomplete
      fetchOptions={fetchRoles}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      {...props}
    />
  );
};
